export enum LINKS {
  PDPA = 'https://ntuchealth.sg/privacy-policy/',
  Website = 'https://ntuchealth.sg/',
  SupportPhoneNumber = '+65 9028 2440',
  ContactUs = 'https://ntuchealth.sg/contact-us'
}
